import React from "react";
import { Helmet } from "react-helmet-async";
import EventContainer from "../../layouts/eventcontainer/eventContainer";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import "./style.css";
import Pongal2k25_Img_1 from "../../../assets/images/gallery/2025/jan/pongal festival/Img  (1).jpeg";
import Pongal2k25_Img_2 from "../../../assets/images/gallery/2025/jan/pongal festival/Img  (2).jpeg";
import Pongal2k25_Img_3 from "../../../assets/images/gallery/2025/jan/pongal festival/Img  (3).jpeg";
import Pongal2k25_Img_4 from "../../../assets/images/gallery/2025/jan/pongal festival/Img  (4).jpeg";
import Pongal2k25_Img_5 from "../../../assets/images/gallery/2025/jan/pongal festival/Img  (5).jpeg";
import Pongal2k25_Img_6 from "../../../assets/images/gallery/2025/jan/pongal festival/Img  (6).jpeg";
import Pongal2k25_Img_7 from "../../../assets/images/gallery/2025/jan/pongal festival/Img  (7).jpeg";

import ScienceExpo_Img_1 from "../../../assets/images/gallery/2025/jan/sci/Sci (1).jpeg";
import ScienceExpo_Img_2 from "../../../assets/images/gallery/2025/jan/sci/Sci (2).jpeg";
import ScienceExpo_Img_3 from "../../../assets/images/gallery/2025/jan/sci/Sci (3).jpeg";
import ScienceExpo_Img_4 from "../../../assets/images/gallery/2025/jan/sci/Sci (4).jpeg";
import ScienceExpo_Img_5 from "../../../assets/images/gallery/2025/jan/sci/Sci (5).jpeg";
import ScienceExpo_Img_6 from "../../../assets/images/gallery/2025/jan/sci/Sci (5).JPG";
import ScienceExpo_Img_7 from "../../../assets/images/gallery/2025/jan/sci/Sci (1).JPG";

import PlacementTrainning_Img_1 from "../../../assets/images/Placement/New folder/Img (1).jpg";
import PlacementTrainning_Img_2 from "../../../assets/images/Placement/New folder/Img (2).jpg";
import PlacementTrainning_Img_3 from "../../../assets/images/Placement/New folder/Img (3).jpg";
import PlacementTrainning_Img_4 from "../../../assets/images/Placement/New folder/Img (4).jpg";
import PlacementTrainning_Img_5 from "../../../assets/images/Placement/New folder/Img (5).jpg";

import Marathon_Img_1 from "../../../assets/images/gallery/2025/march/rally/1.jpeg";
import Marathon_Img_2 from "../../../assets/images/gallery/2025/march/rally/Status.jpg";

import Nilavembukashayam_March_Img_1 from "../../../assets/images/gallery/2025/march/rally/Img  (1).jpeg";
import Nilavembukashayam_March_Img_2 from "../../../assets/images/gallery/2025/march/rally/Img  (2).jpeg";
import Nilavembukashayam_March_Img_3 from "../../../assets/images/gallery/2025/march/rally/Img  (3).jpeg";
import Nilavembukashayam_March_Img_4 from "../../../assets/images/gallery/2025/march/rally/Img  (4).jpeg";
import Nilavembukashayam_March_Img_5 from "../../../assets/images/gallery/2025/march/rally/Img  (5).jpeg";
import Nilavembukashayam_March_Img_6 from "../../../assets/images/gallery/2025/march/rally/Img  (6).jpeg";
import Nilavembukashayam_March_Img_7 from "../../../assets/images/gallery/2025/march/rally/Img  (7).jpeg";

import WomensDay_Img_1 from "../../../assets/images/gallery/2025/march/womensday/img  (1).JPG";
import WomensDay_Img_2 from "../../../assets/images/gallery/2025/march/womensday/img  (2).JPG";
import WomensDay_Img_3 from "../../../assets/images/gallery/2025/march/womensday/img  (3).JPG";
import WomensDay_Img_4 from "../../../assets/images/gallery/2025/march/womensday/img  (4).JPG";
import WomensDay_Img_5 from "../../../assets/images/gallery/2025/march/womensday/img  (5).JPG";
import WomensDay_Img_6 from "../../../assets/images/gallery/2025/march/womensday/img  (6).JPG";
import WomensDay_Img_7 from "../../../assets/images/gallery/2025/march/womensday/img  (7).JPG";
import WomensDay_Img_8 from "../../../assets/images/gallery/2025/march/womensday/img  (8).JPG";

import PlacementCell_1_Img_1 from "../../../assets/images/gallery/2025/jan/placement/Img  (1).jpeg";
import PlacementCell_1_Img_2 from "../../../assets/images/gallery/2025/jan/placement/Img  (2).jpeg";
import PlacementCell_1_Img_3 from "../../../assets/images/gallery/2025/jan/placement/Img  (3).jpeg";

import PlacementCell_2_Img_1 from "../../../assets/images/gallery/2025/march/placemet/Img  (1).jpeg";
import PlacementCell_2_Img_2 from "../../../assets/images/gallery/2025/march/placemet/Img  (2).jpeg";
import PlacementCell_2_Img_3 from "../../../assets/images/gallery/2025/march/placemet/Img  (3).jpeg";

import PlacementCell_3_Img_1 from "../../../assets/images/gallery/2025/march/placemet/IMG  (4).jpeg";
import PlacementCell_3_Img_2 from "../../../assets/images/gallery/2025/march/placemet/IMG  (5).jpeg";
import PlacementCell_3_Img_4 from "../../../assets/images/gallery/2025/march/placemet/IMG  (6).jpeg";
import PlacementCell_3_Img_3 from "../../../assets/images/gallery/2025/march/placemet/IMG  (7).jpeg";

import July_Img_1 from "../../../assets/images/gallery/2025/July/Tamil depatment/Img  (1).jpeg";
import July_Img_2 from "../../../assets/images/gallery/2025/July/Tamil depatment/Img  (2).jpeg";
import July_Img_3 from "../../../assets/images/gallery/2025/July/Tamil depatment/Img  (3).jpeg";
import July_Img_4 from "../../../assets/images/gallery/2025/July/Tamil depatment/Img  (4).jpeg";

import July_2_Img_1 from "../../../assets/images/gallery/2025/July/Freshersday/img  (1).jpeg";
import July_2_Img_2 from "../../../assets/images/gallery/2025/July/Freshersday/img  (2).jpeg";
import July_2_Img_3 from "../../../assets/images/gallery/2025/July/Freshersday/img  (3).jpeg";
import July_2_Img_4 from "../../../assets/images/gallery/2025/July/Freshersday/img  (4).jpeg";
import July_2_Img_5 from "../../../assets/images/gallery/2025/July/Freshersday/img  (5).jpeg";
import July_2_Img_6 from "../../../assets/images/gallery/2025/July/Freshersday/img  (6).jpeg";
import July_2_Img_7 from "../../../assets/images/gallery/2025/July/Freshersday/img  (7).jpeg";
import July_2_Img_8 from "../../../assets/images/gallery/2025/July/Freshersday/img  (8).jpeg";
import July_2_Img_9 from "../../../assets/images/gallery/2025/July/Freshersday/img  (9).jpeg";
import July_2_Img_10 from "../../../assets/images/gallery/2025/July/Freshersday/img  (10).jpeg";

import July_3_Img_1 from "../../../assets/images/gallery/2025/July/Food festival/Img (1).jpeg";
import July_3_Img_2 from "../../../assets/images/gallery/2025/July/Food festival/Img (2).jpeg";
import July_3_Img_3 from "../../../assets/images/gallery/2025/July/Food festival/Img (3).jpeg";
import July_3_Img_4 from "../../../assets/images/gallery/2025/July/Food festival/Img (4).jpeg";
import July_3_Img_5 from "../../../assets/images/gallery/2025/July/Food festival/Img (5).jpeg";
import July_3_Img_6 from "../../../assets/images/gallery/2025/July/Food festival/Img (6).jpeg";
import July_3_Img_7 from "../../../assets/images/gallery/2025/July/Food festival/Img (7).jpeg";
import July_3_Img_8 from "../../../assets/images/gallery/2025/July/Food festival/Img (8).jpeg";
import July_3_Img_9 from "../../../assets/images/gallery/2025/July/Food festival/Img (9).jpeg";

import Aug_1_Img_1 from "../../../assets/images/gallery/2025/Aug/Tamil ilakiya vila/IMG (1).jpeg";
import Aug_1_Img_2 from "../../../assets/images/gallery/2025/Aug/Tamil ilakiya vila/IMG (2).jpeg";
import Aug_1_Img_3 from "../../../assets/images/gallery/2025/Aug/Tamil ilakiya vila/IMG (3).jpeg";
import Aug_1_Img_4 from "../../../assets/images/gallery/2025/Aug/Tamil ilakiya vila/IMG (4).jpeg";
import Aug_1_Img_5 from "../../../assets/images/gallery/2025/Aug/Tamil ilakiya vila/IMG (5).jpeg";
import Aug_1_Img_6 from "../../../assets/images/gallery/2025/Aug/Tamil ilakiya vila/IMG (6).jpeg";
import Aug_1_Img_7 from "../../../assets/images/gallery/2025/Aug/Tamil ilakiya vila/IMG (7).jpeg";
import Aug_1_Img_8 from "../../../assets/images/gallery/2025/Aug/Tamil ilakiya vila/IMG (8).jpeg";
import Aug_1_Img_9 from "../../../assets/images/gallery/2025/Aug/Tamil ilakiya vila/IMG (9).jpeg";

import Aug_2_Img_1  from "../../../assets/images/gallery/2025/Aug/Nss/Img (1).jpeg";
import Aug_2_Img_2  from "../../../assets/images/gallery/2025/Aug/Nss/Img (2).jpeg";
import Aug_2_Img_3  from "../../../assets/images/gallery/2025/Aug/Nss/Img (3).jpeg";
import Aug_2_Img_4  from "../../../assets/images/gallery/2025/Aug/Nss/Img (4).jpeg";
import Aug_2_Img_5  from "../../../assets/images/gallery/2025/Aug/Nss/Img (5).jpeg";
import Aug_2_Img_6  from "../../../assets/images/gallery/2025/Aug/Nss/Img (6).jpeg";

import Aug_3_Img_1 from "../../../assets/images/gallery/2025/Aug/guest lectur/Img  (1).jpeg";
import Aug_3_Img_2 from "../../../assets/images/gallery/2025/Aug/guest lectur/Img  (2).jpeg";
import Aug_3_Img_3 from "../../../assets/images/gallery/2025/Aug/guest lectur/Img  (3).jpeg";
import Aug_3_Img_4 from "../../../assets/images/gallery/2025/Aug/guest lectur/Img  (4).jpeg";
import Aug_3_Img_5 from "../../../assets/images/gallery/2025/Aug/guest lectur/Img  (5).jpeg";
import Aug_3_Img_6 from "../../../assets/images/gallery/2025/Aug/guest lectur/Img  (6).jpeg";

import Aug_4_Img_1 from "../../../assets/images/gallery/2025/Aug/Guest lectur -ai/Img  (1).jpeg";
import Aug_4_Img_2 from "../../../assets/images/gallery/2025/Aug/Guest lectur -ai/Img  (2).jpeg";
import Aug_4_Img_3 from "../../../assets/images/gallery/2025/Aug/Guest lectur -ai/Img  (3).jpeg";
import Aug_4_Img_4 from "../../../assets/images/gallery/2025/Aug/Guest lectur -ai/Img  (4).jpeg";
import Aug_4_Img_5 from "../../../assets/images/gallery/2025/Aug/Guest lectur -ai/Img  (5).jpeg";
import Aug_4_Img_6 from "../../../assets/images/gallery/2025/Aug/Guest lectur -ai/Img  (6).jpeg";
import Aug_4_Img_7 from "../../../assets/images/gallery/2025/Aug/Guest lectur -ai/Img  (7).jpeg";
import Aug_4_Img_8 from "../../../assets/images/gallery/2025/Aug/Guest lectur -ai/Img  (8).jpeg";

import Aug_5_Img_1 from "../../../assets/images/gallery/2025/Aug/micro biolozoy/Img  (1).jpeg";
import Aug_5_Img_2 from "../../../assets/images/gallery/2025/Aug/micro biolozoy/Img  (2).jpeg";
import Aug_5_Img_3 from "../../../assets/images/gallery/2025/Aug/micro biolozoy/Img  (3).jpeg";
import Aug_5_Img_4 from "../../../assets/images/gallery/2025/Aug/micro biolozoy/Img  (4).jpeg";
import Aug_5_Img_5 from "../../../assets/images/gallery/2025/Aug/micro biolozoy/Img  (5).jpeg";
import Aug_5_Img_6 from "../../../assets/images/gallery/2025/Aug/micro biolozoy/Img  (6).jpeg";
import Aug_5_Img_7 from "../../../assets/images/gallery/2025/Aug/micro biolozoy/Img  (7).jpeg";

import Sep_1_Img_1 from "../../../assets/images/gallery/2025/sep/onam celebration/IMG (1).jpeg";
import Sep_1_Img_2 from "../../../assets/images/gallery/2025/sep/onam celebration/IMG (2).jpeg";
import Sep_1_Img_3 from "../../../assets/images/gallery/2025/sep/onam celebration/IMG (3).jpeg";
import Sep_1_Img_4 from "../../../assets/images/gallery/2025/sep/onam celebration/IMG (4).jpeg";
import Sep_1_Img_5 from "../../../assets/images/gallery/2025/sep/onam celebration/IMG (5).jpeg";
import Sep_1_Img_6 from "../../../assets/images/gallery/2025/sep/onam celebration/IMG (6).jpeg";
import Sep_1_Img_7 from "../../../assets/images/gallery/2025/sep/onam celebration/IMG (7).jpeg";
import Sep_1_Img_8 from "../../../assets/images/gallery/2025/sep/onam celebration/IMG (8).jpeg";

import Sep_2_Img_1 from "../../../assets/images/gallery/2025/sep/Naan Mudhalvan/Img (1).jpeg";
import Sep_2_Img_2 from "../../../assets/images/gallery/2025/sep/Naan Mudhalvan/Img (2).jpeg";



import Gallery from "./Gallerynew/Gallery";

const Moments2025 = () => {
  const Pongal2k25 = [
    {
      image: Pongal2k25_Img_1,
      altText: "",
      caption: "",
      id: "pongal2k25",
    },
    {
      image: Pongal2k25_Img_2,
      altText: "",
      caption: "",
      id: "pongal2k25",
    },
    {
      image: Pongal2k25_Img_3,
      altText: "",
      caption: "",
      id: "pongal2k25",
    },
    {
      image: Pongal2k25_Img_4,
      altText: "",
      caption: "",
      id: "pongal2k25",
    },
    {
      image: Pongal2k25_Img_6,
      altText: "",
      caption: "",
      id: "pongal2k25",
    },
    {
      image: Pongal2k25_Img_5,
      altText: "",
      caption: "",
      id: "pongal2k25",
    },
    {
      image: Pongal2k25_Img_7,
      altText: "",
      caption: "",
      id: "pongal2k25",
    },
  ];
  const ScienceExpo = [
    {
      image: ScienceExpo_Img_1,
      altText: "",
      caption: "",
      id: "ScienceExpo",
    },
    {
      image: ScienceExpo_Img_2,
      altText: "",
      caption: "",
      id: "ScienceExpo",
    },
    {
      image: ScienceExpo_Img_3,
      altText: "",
      caption: "",
      id: "ScienceExpo",
    },
    {
      image: ScienceExpo_Img_4,
      altText: "",
      caption: "",
      id: "ScienceExpo",
    },
    {
      image: ScienceExpo_Img_5,
      altText: "",
      caption: "",
      id: "ScienceExpo",
    },
    {
      image: ScienceExpo_Img_6,
      altText: "",
      caption: "",
      id: "ScienceExpo",
    },

    {
      image: ScienceExpo_Img_7,
      altText: "",
      caption: "",
      id: "ScienceExpo",
    },
  ];
  const PlacementTrainning = [
    {
      image: PlacementTrainning_Img_1,
      altText: "",
      caption: "",
      id: "placement-",
    },
    {
      image: PlacementTrainning_Img_2,
      altText: "",
      caption: "",
      id: "placement-",
    },
    {
      image: PlacementTrainning_Img_3,
      altText: "",
      caption: "",
      id: "placement-",
    },
    {
      image: PlacementTrainning_Img_4,
      altText: "",
      caption: "",
      id: "placement-",
    },
    {
      image: PlacementTrainning_Img_5,
      altText: "",
      caption: "",
      id: "placement-",
    },
  ];
  const Marathon = [
    {
      image: Marathon_Img_1,
      altText: "",
      caption: "",
      id: "marathon",
    },
    {
      image: Marathon_Img_2,
      altText: "",
      caption: "",
      id: "marathon",
    },
  ];
  const Nilavembukashayam_March = [
    {
      image: Nilavembukashayam_March_Img_1,
      altText: "",
      caption: "",
      id: "nilavembukashayam-march",
    },
    {
      image: Nilavembukashayam_March_Img_2,
      altText: "",
      caption: "",
      id: "nilavembukashayam-march",
    },
    {
      image: Nilavembukashayam_March_Img_3,
      altText: "",
      caption: "",
      id: "nilavembukashayam-march",
    },
    {
      image: Nilavembukashayam_March_Img_4,
      altText: "",
      caption: "",
      id: "nilavembukashayam-march",
    },
    {
      image: Nilavembukashayam_March_Img_5,
      altText: "",
      caption: "",
      id: "nilavembukashayam-march",
    },
    {
      image: Nilavembukashayam_March_Img_6,
      altText: "",
      caption: "",
      id: "nilavembukashayam-march",
    },
    {
      image: Nilavembukashayam_March_Img_7,
      altText: "",
      caption: "",
      id: "nilavembukashayam-march",
    },
  ];
  const WomensDay = [
    {
      image:WomensDay_Img_1,
      altText: "",
      caption: "",
      id: "womensday",
    },
    {
      image:WomensDay_Img_2,
      altText: "",
      caption: "",
      id: "womensday",
    },
    {
      image:WomensDay_Img_3,
      altText: "",
      caption: "",
      id: "womensday",
    },
    {
      image:WomensDay_Img_4,
      altText: "",
      caption: "",
      id: "womensday",
    },
    {
      image:WomensDay_Img_5,
      altText: "",
      caption: "",
      id: "womensday",
    },
    {
      image:WomensDay_Img_6,
      altText: "",
      caption: "",
      id: "womensday",
    },
    {
      image:WomensDay_Img_7,
      altText: "",
      caption: "",
      id: "womensday",
    },
    {
      image:WomensDay_Img_8,
      altText: "",
      caption: "",
      id: "womensday",
    },
  ];
const PlacementCell_1 =[
  {
    image: PlacementCell_1_Img_1,
      altText: "",
      caption: "",
      id: "placementcell-1",
  },
  {
    image: PlacementCell_1_Img_2,
      altText: "",
      caption: "",
      id: "placementcell-1",
  },
  {
    image: PlacementCell_1_Img_3,
      altText: "",
      caption: "",
      id: "placementcell-1",
  },
];
const PlacementCell_2 =[
  {
    image: PlacementCell_2_Img_1,
      altText: "",
      caption: "",
      id: "placementcell-2",
  },
  {
    image: PlacementCell_2_Img_2,
      altText: "",
      caption: "",
      id: "placementcell-2",
  },
  {
    image: PlacementCell_2_Img_3,
      altText: "",
      caption: "",
      id: "placementcell-2",
  },
];

const PlacementCell_3 =[
  {
    image:PlacementCell_3_Img_1,
      altText: "",
      caption: "",
      id: "placementcell_3",
  },
  {
    image:PlacementCell_3_Img_2,
      altText: "",
      caption: "",
      id: "placementcell_3",
  },
  {
    image:PlacementCell_3_Img_3,
      altText: "",
      caption: "",
      id: "placementcell_3",
  },
  {
    image:PlacementCell_3_Img_4,
      altText: "",
      caption: "",
      id: "placementcell_3",
  },

];
const July_1 =[
  {
     image:July_Img_1,
      altText: "",
      caption: "",
      id: "july-1",
  },
  {
     image:July_Img_2,
      altText: "",
      caption: "",
      id: "july-1",
  },
  {
     image:July_Img_3,
      altText: "",
      caption: "",
      id: "july-1",
  },
  {
     image:July_Img_4,
      altText: "",
      caption: "",
      id: "july-1",
  },
  
];
const July_2 =[
  
    {
     image:July_2_Img_1,
      altText: "",
      caption: "",
      id: "july-2",
  },
   {
     image:July_2_Img_2,
      altText: "",
      caption: "",
      id: "july-2",
  },
   {
     image:July_2_Img_3,
      altText: "",
      caption: "",
      id: "july-2",
  },
   {
     image:July_2_Img_4,
      altText: "",
      caption: "",
      id: "july-2",
  },
   {
     image:July_2_Img_5,
      altText: "",
      caption: "",
      id: "july-2",
  },
   {
     image:July_2_Img_6,
      altText: "",
      caption: "",
      id: "july-2",
  },
   {
     image:July_2_Img_7,
      altText: "",
      caption: "",
      id: "july-2",
  },
   {
     image:July_2_Img_8,
      altText: "",
      caption: "",
      id: "july-2",
  },
   {
     image:July_2_Img_9,
      altText: "",
      caption: "",
      id: "july-2",
  },
   {
     image:July_2_Img_10,
      altText: "",
      caption: "",
      id: "july-2",
  },
  
];
const July_3 = [
  {
      image:July_3_Img_1,
      altText: "",
      caption: "",
      id: "july-3",
  },
  {
      image:July_3_Img_2,
      altText: "",
      caption: "",
      id: "july-3",
  },
  {
      image:July_3_Img_3,
      altText: "",
      caption: "",
      id: "july-3",
  },
  {
      image:July_3_Img_4,
      altText: "",
      caption: "",
      id: "july-3",
  },
  {
      image:July_3_Img_5,
      altText: "",
      caption: "",
      id: "july-3",
  },
  {
      image:July_3_Img_6,
      altText: "",
      caption: "",
      id: "july-3",
  },
  {
      image:July_3_Img_7,
      altText: "",
      caption: "",
      id: "july-3",
  },
  {
      image:July_3_Img_8,
      altText: "",
      caption: "",
      id: "july-3",
  },
  {
      image:July_3_Img_9,
      altText: "",
      caption: "",
      id: "july-3",
  },
 
];
const Aug_1 = [
  {
      image:Aug_1_Img_1,
      altText: "",
      caption: "",
      id: "aug-1",
  },
   {
      image:Aug_1_Img_2,
      altText: "",
      caption: "",
      id: "aug-1",
  },
   {
      image:Aug_1_Img_3,
      altText: "",
      caption: "",
      id: "aug-1",
  },
   {
      image:Aug_1_Img_4,
      altText: "",
      caption: "",
      id: "aug-1",
  },
   {
      image:Aug_1_Img_5,
      altText: "",
      caption: "",
      id: "aug-1",
  },
   {
      image:Aug_1_Img_6,
      altText: "",
      caption: "",
      id: "aug-1",
  },
   {
      image:Aug_1_Img_7,
      altText: "",
      caption: "",
      id: "aug-1",
  },
   {
      image:Aug_1_Img_8,
      altText: "",
      caption: "",
      id: "aug-1",
  },
   {
      image:Aug_1_Img_9,
      altText: "",
      caption: "",
      id: "aug-1",
  },
];
const Aug_2 = [
  {
      image:Aug_2_Img_1,
      altText: "",
      caption: "",
      id: "aug-2",
  },
   {
      image:Aug_2_Img_2,
      altText: "",
      caption: "",
      id: "aug-2",
  },
   {
      image:Aug_2_Img_3,
      altText: "",
      caption: "",
      id: "aug-2",
  },
   {
      image:Aug_2_Img_4,
      altText: "",
      caption: "",
      id: "aug-2",
  },
   {
      image:Aug_2_Img_5,
      altText: "",
      caption: "",
      id: "aug-2",
  },
   {
      image:Aug_2_Img_6,
      altText: "",
      caption: "",
      id: "aug-2",
  },
 ];
 const Aug_3 = [
  {
      image:Aug_3_Img_1,
      altText: "",
      caption: "",
      id: "aug-3",
  },
   {
      image:Aug_3_Img_2,
      altText: "",
      caption: "",
      id: "aug-3",
  },
   {
      image:Aug_3_Img_3,
      altText: "",
      caption: "",
      id: "aug-3",
  },
   {
      image:Aug_3_Img_4,
      altText: "",
      caption: "",
      id: "aug-3",
  },
   {
      image:Aug_3_Img_5,
      altText: "",
      caption: "",
      id: "aug-3",
  },
   {
      image:Aug_3_Img_6,
      altText: "",
      caption: "",
      id: "aug-3",
  },
 ];
const Aug_4 =[
  {
      image:Aug_4_Img_1,
      altText: "",
      caption: "",
      id: "aug-4",
  },
  {
      image:Aug_4_Img_2,
      altText: "",
      caption: "",
      id: "aug-4",
  },
  {
      image:Aug_4_Img_3,
      altText: "",
      caption: "",
      id: "aug-4",
  },
  {
      image:Aug_4_Img_4,
      altText: "",
      caption: "",
      id: "aug-4",
  },
  {
      image:Aug_4_Img_5,
      altText: "",
      caption: "",
      id: "aug-4",
  },
  {
      image:Aug_4_Img_6,
      altText: "",
      caption: "",
      id: "aug-4",
  },
  {
      image:Aug_4_Img_7,
      altText: "",
      caption: "",
      id: "aug-4",
  },
  {
      image:Aug_4_Img_8,
      altText: "",
      caption: "",
      id: "aug-4",
  },
];
const Aug_5 =[
  {
     image:Aug_5_Img_1,
     altText: "",
     caption: "",
     id: "aug-5",
  },
  {
     image:Aug_5_Img_2,
     altText: "",
     caption: "",
     id: "aug-5",
  },
  {
     image:Aug_5_Img_3,
     altText: "",
     caption: "",
     id: "aug-5",
  },
  {
     image:Aug_5_Img_4,
     altText: "",
     caption: "",
     id: "aug-5",
  },
  {
     image:Aug_5_Img_5,
     altText: "",
     caption: "",
     id: "aug-5",
  },
  {
     image:Aug_5_Img_6,
     altText: "",
     caption: "",
     id: "aug-5",
  },
  {
     image:Aug_5_Img_7,
     altText: "",
     caption: "",
     id: "aug-5",
  },
];
const Sep_1 =[
  {
     image:Sep_1_Img_1,
     altText: "",
     caption: "",
     id: "sep-1",
  },
  {
     image:Sep_1_Img_2,
     altText: "",
     caption: "",
     id: "sep-1",
  },
  {
     image:Sep_1_Img_3,
     altText: "",
     caption: "",
     id: "sep-1",
  },
  {
     image:Sep_1_Img_4,
     altText: "",
     caption: "",
     id: "sep-1",
  },
  {
     image:Sep_1_Img_5,
     altText: "",
     caption: "",
     id: "sep-1",
  },
  {
     image:Sep_1_Img_6,
     altText: "",
     caption: "",
     id: "sep-1",
  },
  {
     image:Sep_1_Img_7,
     altText: "",
     caption: "",
     id: "sep-1",
  },
  {
     image:Sep_1_Img_8,
     altText: "",
     caption: "",
     id: "sep-1",
  },

];
const Sep_2 = [
  {
      image:Sep_2_Img_1,
     altText: "",
     caption: "",
     id: "sep-2",
  },
  {
      image:Sep_2_Img_2,
     altText: "",
     caption: "",
     id: "sep-2",
  },
]
  return (
    <>
      <Helmet>
        <title> Gallery-JNCW </title>
      </Helmet>

      <div className="container">
      {/* <Gallery/> */}
        <div class="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h5 class="section-title bg-white text-center text-primary px-3">
            Gallery
          </h5>
          <h4 class="mb-5">JNCW-2025 Moments</h4>
        </div>
        {/* <GalleryPage/> */}
        <EventContainer
          data={Sep_2}
          header="Students Qualify for Naan Mudhalvan Employability Programme"
          id="sep-2"
        />
          <EventContainer
          data={Sep_1}
          header="Onam Celebrations-2k25"
          id="sep-1"
        />
           <EventContainer
          data={Aug_5}
          header="Guest Lecture Program-Hidden World of Microbes/Microbiomes"
          id="Aug-5"
        />
     
           <EventContainer
          data={Aug_4}
          header="Guest Lecture Program-Artificial Intelligence "
          id="Aug-4"
        />
        <EventContainer
          data={Aug_3}
          header="Guest Lecture Program-Applications of Nanotechnology"
          id="Aug-3"
        />
        <EventContainer
          data={Aug_2}
          header="நாட்டு நல பணித் திட்டத்தின் NSS Camp-2K25"
          id="Aug-2"
        />
          <EventContainer
          data={Aug_1}
          header="முத்தமிழ் இலக்கிய மன்ற விழா"
          id="aug-1"
        />
        <EventContainer
          data={July_3}
          header="Food Festival 2K25"
          id="july-3"
        />
         <EventContainer
          data={July_2}
          header="Fresh Fiesta 25, Freshers' Day celebration"
          id="july-2"
        />
         <EventContainer
          data={July_1}
          header="திருக்கோவிலூர் கள ஆய்வு – 2025"
          id="july-1"
        />
        <EventContainer
          data={PlacementCell_3}
          header="On Campus Drive Marcg 2025"
          id="placementcell-3"
        />
 <EventContainer
          data={PlacementCell_2}
          header="Leadership event conducted on behalf of Placement Cell"
          id="placementcell-2"
        />


        <EventContainer
          data={WomensDay}
          header="Women's Day Celebrations"
          id="womensday"
        />


        <EventContainer
          data={Nilavembukashayam_March}
          header="NILAVEMBU KASHAYAM CAMP CONDUCTED AT ULUNDURPET BUS STAND ON 07/03/2025"
          id="nilavembukashayam-march"
        />
        <EventContainer
          data={Marathon}
          header="Marathon on 07.03.2024 to celebrate International Women's Day"
          id="marathon"
        />
 <EventContainer
          data={PlacementCell_1}
          header="Campus Drive on 29th Jan 2025"
          id="placementcell-1"
        />
        <EventContainer
          data={PlacementTrainning}
          header="Placement Trainning - Leadership Event for Aspiring Young Women"
          id="placement-1"
        />
        <EventContainer
          data={ScienceExpo}
          header="Science Expo 2k25"
          id="scienceexpo"
        />

        <EventContainer
          data={Pongal2k25}
          header="Pongal Celebrations-2025"
          id="pongal2k25"
        />
      </div>
    </>
  );
};

export default Moments2025;
